


























































































import { Component, Prop } from 'vue-property-decorator';
import LoadingCircle from '@/components/loading-circle.vue';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
    LoadingCircle
  }
})
export default class UiButton extends mixins(PlanLimitsMixin) {
  @Prop({ default: '' })
  href: string;

  @Prop()
  icon: string;

  @Prop()
  helpTooltip: string;

  @Prop()
  menuKeyOfSelectedItem: string;

  @Prop()
  menuProps: any;

  @Prop()
  color: string;

  @Prop()
  to: object;

  @Prop()
  contentColor: string;

  @Prop({default: false})
  forceChevron: boolean;

  @Prop({default: false})
  forceHideChevron: boolean;

  @Prop()
  menuList: Bemob.ListItem[];

  @Prop({default: false})
  dontOpenMenu: boolean;

  @Prop()
  menuContentClass: string;

  @Prop()
  iconAppend: string;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: 'default' })
  buttonStyle: string;

  @Prop({ default: '_blank' })
  target: string;

  @Prop({ default: '' })
  text: string;

  @Prop()
  loading: boolean;

  @Prop()
  size: null | 'mini' | 'micro' | 'large'

  @Prop({ default: false })
  isMenuOpen: boolean;

  toggleMenu(isOpen: boolean = !this.isMenuOpen) {
    this.isMenuOpen = isOpen
  }

  get hasMenu() {
    return !!(this.menuList?.length || this.$slots['menu'] || this.$slots['item'])
  }

  get pMenuProps() {
    const menuProps: any = this.menuProps || {};

    return {
      nudgeRight: 10,
      nudgeBottom: this.size==='mini' ? 8 : 12,
      left: true,
      bottom: true,
      ...menuProps
    }
  }

  onClick() {
    if(this.showPlanLimitsIcon){return this.handleClickPlanLimits()}
    this.$emit('click')
    if(!this.dontOpenMenu && this.hasMenu) {
      this.toggleMenu()
      this.$emit('update:isMenuOpen', this.isMenuOpen)
    }

    if (this.href) {
      window.open(this.href, this.target);
    }

    if (this.to) {
      this.$router.push(this.to)
    }
  }

}
